import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { setTrackLink } from '@vfit/shared/data-access';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';
import { getEnergyTagging, getUserInfo } from '../../checkoutEnergy.utils';
import { useEnergyCheckout } from '../../../energy.context';

const TaggingComponent = () => {
  const { product } = useEnergyCheckout();
  const tagging = getEnergyTagging(product, 'OTP');

  const { trackView } = useTracking({
    event: ['checkout_step1.2'],
    event_label: 'OTP',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'OTP');
  setTrackView(trackView);

  return null;
};

const TaggingOtpCard = withAnimationDelay()(TaggingComponent);

export default TaggingOtpCard;

